import React from 'react';
import Dialog from '@mui/material/Dialog';
import PropTypes from 'prop-types';

import { StyledCloseIcon, StyledIconButton, ModalHeader } from './index.styles';

export const Modal = ({
  open,
  children,
  showHeader,
  showTopCornerCloseButton,
  onClose
}) => {
  return (
    <Dialog open={open} onClose={onClose}>
      {showHeader && (
        <ModalHeader>
          {showTopCornerCloseButton && (
            <StyledIconButton
              edge="start"
              color="inherit"
              onClick={onClose}
              aria-label="close"
              size="small"
            >
              <StyledCloseIcon />
            </StyledIconButton>
          )}
        </ModalHeader>
      )}
      {children}
    </Dialog>
  );
};

Modal.propTypes = {
  showHeader: PropTypes.bool,
  showTopCornerCloseButton: PropTypes.bool,
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  children: PropTypes.node.isRequired
};

Modal.defaultProps = {
  showHeader: false,
  showTopCornerCloseButton: false
};

export default Modal;
